import type FindMeetingTimeSlot from 'owa-calendar-scheduling-service/lib/schema/FindMeetingTimeSlot';
import { owaDate, addMinutes, differenceInMinutes } from 'owa-datetime';
import type { OwaDateRange } from 'owa-datetime-utils/lib/OwaDateRange';
import { getConfiguredEventStartTimeBasedOnPreviousDuration } from 'owa-calendar-cloud-settings-utils';
import shouldAdjustStartEndTimeForDuration from './shouldAdjustStartEndTimeForDuration';
import { getShortenedDuration } from './durationOptionsUtils';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';

/**
 * Converts the DateTimeTimeZone returned by the FindMeetingTimes call into a OwaDate in the user's timezone
 * @param timeSlot The time slot returned by the FindMeetingTimes call
 */
export default function convertMeetingTimeSlotIntoOwaDates(
    timeSlot: FindMeetingTimeSlot,
    event: CalendarEvent,
    viewStateId: string | null
): OwaDateRange {
    const dateRange: OwaDateRange = {
        start: owaDate(timeSlot.Start.TimeZone, timeSlot.Start.DateTime),
        end: owaDate(timeSlot.End.TimeZone, timeSlot.End.DateTime),
    };

    // We need to know if the event duration matches one of our adjustedDefaultDurations,
    // in which case we need to adjust the time suggestion for display puporses.
    // If instead, the user has a custom duration we won't apply shortenedEventsLogic.
    let currentEventDuration = differenceInMinutes(event.End, event.Start);
    if (shouldAdjustStartEndTimeForDuration(currentEventDuration, viewStateId)) {
        // Adjust start and end based on the shorten event duration setting
        const duration = differenceInMinutes(dateRange.end, dateRange.start);
        dateRange.start = getConfiguredEventStartTimeBasedOnPreviousDuration(
            duration,
            dateRange.start
        );
        const shortenedDuration = getShortenedDuration(duration);
        dateRange.end = addMinutes(dateRange.start, shortenedDuration);
    }

    return dateRange;
}
